import * as React from "react";
const Search = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M20.53 19.46l-4.476-4.476a7.31 7.31 0 10-1.079 1.042l4.495 4.495a.75.75 0 001.06-1.061zM4.75 10.333a5.75 5.75 0 119.78 4.095.746.746 0 00-.078.071 5.742 5.742 0 01-9.702-4.165z" />
  </symbol>;
export default Search;